<div [ngClass]="this.language == null || this.language === 'en' ? 'pre-login-en-css' : 'pre-login-other-css'">
  <div class="signup-verify-bgImg">
    <div class="card signup-verify-details" style="width: 450px">
      <div class="text-center">
        <h5 class="mt-4 mb-2 fw-bold google-verfify-details">
          {{ "SIGNUP.VERIFYDETAILS" | translate }}
        </h5>
      </div>
      <!-- Modal body -->
      <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
        <div class="form-div mb-5">
          <div class="form-group">
            <div class="mt-3 form-group">
              <label for="name" class="mb-1 q-form-label">
                {{ "SIGNUP.NAME" | translate }}
              </label>
              <input type="text" autocomplete="off" class="q-form-control form-control" [value]="getName" disabled />
            </div>
            <div class="mt-3 form-group">
              <label for="name" class="mb-1 q-form-label">
                {{ "SIGNUP.EMAIL" | translate }}
              </label>
              <input type="text" autocomplete="off" class="q-form-control form-control" [value]="getEmail" disabled />
            </div>
            <ng-container *ngIf="errorMessage">
              <p class="errMessage">{{ errorMessage }}</p>
            </ng-container>
            <ng-container *ngIf="isInvalidEmail">
              <p class="errMessage mw-340">
                {{ invalidEmailStatMsg!=''?invalidEmailStatMsg:("SIGNUP.ENTERVALIDEMAILID" | translate) }}
              </p>
            </ng-container>
          </div>

          <ng-container *ngIf="showCaptcha">
            <ngx-recaptcha2 #captchaElem siteKey="6LcMjEwhAAAAAE2vVJmSbwo8S4lqZithppOd-qlO"
              formControlName="captchaToken">
            </ngx-recaptcha2>
          </ng-container>
          <div class="mt-3">
            <div class="">
              <button type="submit" [disabled]="signUpForm.invalid || isInvalidEmail" [ngClass]="
                  signUpForm.invalid || isInvalidEmail
                    ? 'q-invalid-button mb-3 w-100'
                    : 'submit-btn bg-orgclr mb-3 w-100'
                ">
                {{ "LOGIN.SUBMIT" | translate }}
              </button>
            </div>
            <div>
              <button class="cancel-btn bg-cancelbtn w-100" type="button" routerLink="/">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal" id="signupSuccess" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-3">
            <div>
              <img [src]="'SIGNUP.SUCCESSIMG'|translate" alt="" class="mx-auto" />
            </div>
            <h5 class="fw-bold q-form-heading mt-3">
              {{"SUCESSMESSAGE.Congratulations" | translate }}
            </h5>
            <p class="my-3">
              {{"SUCESSMESSAGE.SuccessGoogleSignup" | translate }}
            </p>
            <button class="submit-btn bg-orgclr w-auto mb-3" type="button" (click)="goToLoginPage()">
              {{"SIGNUP.SIGNIN" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>